export function currencyFormatter(locale, currencyCode, decimals=2) {
    return new Intl.NumberFormat(locale, {
        currency: currencyCode,
        style: 'currency',
        maximumFractionDigits: decimals
    });
}